module.exports = __webpack_public_path__ + "static/mermaid-db36bed90af0b22a09044b1aeac0c19a.png";